export default [
  {
    path: '/digital-replies',
    name: 'digital-replies',
    component: () => import('@/views/DigitalReplies/DigitalRepliesSearch.vue'),
    meta: {
      protected: true,
      pageTitle: 'Replies Search',
      breadcrumb: [
        {
          text: 'Replies Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reply/:id',
    name: 'reply-view',
    props: true,
    component: () => import('@/views/DigitalReplies/DigitalReplyView.vue'),
    meta: {
      protected: true,
      pageTitle: 'View Reply',
      breadcrumb: [
        {
          text: 'View Reply',
          active: true,
        },
      ],
    },
  },
]
